"use client";

import React from "react";

import { createSVGIcon } from "../util";

/** @optimized using svgo:^3.0.2 */
export const CheckInCircle = createSVGIcon(
  <>
    <path
      d="M.571 8a7.428 7.428 0 1 0 14.857 0A7.428 7.428 0 0 0 .571 8Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m4.905 8.738 1.302 1.674a.476.476 0 0 0 .743.01l4.145-5.018"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "CheckInCircle",
  {
    viewBox: "0 0 16 16",
    fill: "none",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
